<script setup lang="ts">
    import { handleTouchStart } from '@/commons/slider/SliderHelper';
    import { ref, useTemplateRef } from 'vue';

    const props = defineProps<{
        show: boolean;
    }>();

    const emit = defineEmits<{
        close: [];
    }>();

    const popupContentRef = useTemplateRef('popupContent');
    const isSwipping = ref(false);

    function closePopup() {
        emit('close');
    }

    function onTouchStart(e: TouchEvent) {
        handleTouchStart({
            event: e,
            elementRef: popupContentRef,
            onClose: closePopup,
            isSwippingRef: isSwipping,
            threshold: 100,
        });
    }
</script>

<template>
    <transition
        enter-active-class="transition-opacity duration-300 ease-out"
        enter-from-class="opacity-0"
        leave-active-class="transition-opacity duration-300 ease-out"
        leave-to-class="opacity-0"
    >
        <div
            v-if="props.show"
            class="fixed inset-x-0 bottom-0 z-20"
        >
            <button
                class="fixed inset-0 bg-black bg-opacity-50"
                @click="closePopup"
            >
                <span class="sr-only">{{ $t('close_popup') }}</span>
            </button>
            <div
                ref="popupContent"
                :class="[isSwipping && 'transition-none', 'relative rounded-t-lg bg-white p-4 shadow-lg']"
            >
                <button
                    class="absolute left-0 right-0 top-0 flex h-6 w-full cursor-pointer justify-center pt-2 focus:outline-none"
                    @click="closePopup"
                    @touchstart="onTouchStart"
                >
                    <span class="sr-only">{{ $t('close_popup') }}</span>
                    <div class="h-1 w-12 rounded-full bg-gray-300"></div>
                </button>

                <div class="mt-3">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>
